<template>
  <div class="actions">
    <ccs-header
      :title="'Журнал'"
      :nightTheme="true"
      :info="false"/>
    <div class="actions-controls">
      <div class="controls-sort">
        <div class="controls-text">Сортировать</div>
        <div class="ccs-dropdown__wrapper">
          <select name="sort" class="ccs-dropdown">
            <option value="value2">↑ По дате</option>
            <option value="value1" selected>↓ По дате</option>
            <option value="value3">По статусу</option>
          </select>
        </div>
      </div>
      <div class="controls-filter">
        <div class="controls-text">Фильтр</div>
        <div class="ccs-dropdown__wrapper">
          <select name="sort" class="ccs-dropdown">
            <option value="1" selected>Ошибка</option>
            <option value="2" selected>Информация</option>
            <option value="3" selected>Предупреждение</option>
          </select>
        </div>
      </div>
    </div>
    <div class="actions-content">
      <div class="actions-card" v-for="i in [1,2,3]" :key="i">
        <div class="card-date">14.10.2019 в 13:06</div>
        <div class="card-text">
          Nam sodales elementum dolor non semper.
          Donec ac risus risus. Proin lacus nulla, bibendum aliquam nibh vel,
          viverra aliquam arcu. Ut eu tempus tellus. Maecenas euismod
          bibendum nisi, eget
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/layouts/Header.vue';

export default {
  name: 'Actions',
  components: {
    'ccs-header': Header,
  },
};
</script>

<style lang="scss" scoped>
.actions {
  min-height: 100%;
  min-width: 100%;
  background: $surfaceDarker;

  &-controls {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &-content {
    margin: 0 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &-card {
    margin-bottom: 20px;
    padding: 15px 20px 24px 15px;
    max-width: 100%;
    min-height: 75px;
    border-radius: 5px;
    background: #fff;
  }

  .controls {

    &-text {
      margin-right: 20px;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
    }

    &-sort, &-filter {
      position: relative;
      margin: 0 0 30px 56px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

  }

  .card-date {
    font-size: 16px;
    font-weight: bold;
    line-height: 150%;
    color: $primary;
  }

  .card-text {
    margin-top: 13px;
    font-size: 16px;
    line-height: 150%;
  }

}
</style>
